import { useSearchParams, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Home from './routes/Home';
import Animations from './routes/Animations';
import Publication from './routes/Publication';
import Team from './routes/Team';
import Statistics from './routes/Statistics';


// import MergedSFR from './routes/MergedSFR';
// import SFRAlaska from './routes/SFRAlaska';
// import SFRCONUS from './routes/SFRCONUS';
// import SFREurope from './routes/SFREurope';
// import SFRSAmerica from './routes/SFRSAmerica';
import SFR from "./components/SFR";
import regions from './JSON/regions.json';
import AnimationGenerator from './routes/AnimationGenerator';

function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(null);
  const location = useLocation(); 

  
  useEffect(() => {
    if (location.pathname.endsWith("/felix/users")) {
      setPage(<Statistics />);
      return;
    }

    const regionMap = Object.entries(regions).reduce((acc, [key, value]) => {
      acc[value.full_name] = key;
      return acc;
    }, {});

    const currPage = searchParams.get('page');
    if(currPage === null){
      setSearchParams({ page: 'Home' });
    } else if(currPage === 'Home') {
      setPage(<Home />);
    } else if(currPage === 'Publication') {
      setPage(<Publication />);
    } else if(currPage === 'Team') {
      setPage(<Team />);
    } else if(currPage === 'AnimationGenerator') {
      setPage(<AnimationGenerator />);
    } else if(regionMap[currPage]){
      setPage(<SFR key={regionMap[currPage]} region={regionMap[currPage]} />);
    } else {
      setSearchParams({ page: 'Home' });
    }

    // switch (searchParams.get('page')) {
    //   case null:
    //     setSearchParams({ page: 'Home' });
    //     break;
    //   case 'Home':
    //     setPage(<Home />);
    //     break;
    //   case 'SFR-CONUS':
    //     setPage(<SFRCONUS />);
    //     break;
    //   case 'SFR-Alaska':
    //     setPage(<SFRAlaska />);
    //     break;
    //   case 'mSFR-CONUS':
    //     setPage(<MergedSFR />);
    //     break;
    //   case 'SFR-Europe':
    //       setPage(<SFREurope />);
    //     break;
    //     case 'SFR-SAmerica':
    //       setPage(<SFRSAmerica />);
    //     break;
    //   case 'Animations':
    //     setPage(<Animations />);
    //     break;
    //   case 'Publication':
    //     setPage(<Publication />);
    //     break;
    //   case 'Team':
    //     setPage(<Team />);
    //     break;
    //  case 'GenerateGif':
    //    setPage(<GenerateGif />);
    //    break;
    //   default:
    //     setSearchParams({ page: 'Home' });
    //     break;
    // }
  }, [searchParams, setSearchParams])

  return (
    <div>
      {page}
    </div>
  );
}

export default App;
